<a class="nav-link"
   (mouseenter)="mouseEnter(facetItem)"
   (mouseleave)="mouseLeave(facetItem)"
   [ngClass]="[style, parentStyle]"
   [class.selected]="facetItem.selected">
  {{facetItem.displayString}}
  <ng-container *ngIf="facetItem.count && facetItem.count > 0">
    ({{ facetItem.count <= 50 ? facetItem.count : "50+" }})
  </ng-container>
</a>
